import React from 'react';
import { Box } from '@mui/material';
import { TP_COLORS } from '../../../../constants/Color';

const CustomStepper: React.FC<{ activeStep: number }> = ({
  activeStep = 0,
}) => {
  const totalSteps = 6;
  return (
    <Box
      position="absolute"
      top="60px"
      display="flex"
      justifyContent="center"
      gap={1}
    >
      {Array.from({ length: totalSteps }).map((_, index) => (
        <Box
          key={index}
          sx={{
            width: 60,
            height: 8,
            borderRadius: 10,
            backgroundColor:
              index <= activeStep
                ? TP_COLORS.gray.darken
                : TP_COLORS.border.color1,
            transition: 'background-color 0.3s ease',
          }}
        />
      ))}
    </Box>
  );
};

export default CustomStepper;
